module.exports = {
      id: "ios-block-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#ios-block",
      toString: function () {
        return this.url;
      }
    }